<template>
	<div id="create">
		<div class="createWrapper">
			<form @submit.prevent="createShow">
				<div class="element">
					<input type="text" v-model="showTitle" name="showTitle"
						   placeholder="Show Titel" class="input_field">
				</div>
				<div class="element">
					<input type="submit" value="Erstellen" class="button">
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import isLoggedIn from '@/services/IsLoggedIn.js';
	import Show from '@/services/Show';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Create",
		data() {
			return {
				showTitle: ''
			}
		},
		methods: {
			async createShow() {

				let newShow = await Show.create({
					title: this.showTitle,
					is_Public: false
				});
				
				this.$router.push({path: '/showedit/' + newShow.id});
			}
		},
		async created() {
			(await isLoggedIn() === false) ? this.$router.push('/login') : '';
			EventBus.$emit('onCurrentShow', '');
		}
	}
</script>

<style scoped>
	#create {
		height: 100%;
		display: flex;
		justify-content: center;
	}

	.createWrapper {
		padding: 50px;
		width: 400px;
		height: 250px;
		margin-top: 50px;
		border: solid 2px black;
	}

	.element {
		display: flex;
		justify-content: space-around;
		margin-top: 12px;
	}

	label {
		color: white;
		width: 30%;
	}

	.input_field {
		padding: 10px 15px 10px 15px;
		font-family: "BrownLLWeb-Regular";
		color: black;
		width: 70%;
		font-size: 20px;
	}

</style>